<template>
    <div>
        <div class="page-loading" v-if="init">
            <van-skeleton title :row="8" />
        </div>
    <template v-else>
        <div id="banner">
<!--            <div class="swiper-container">-->
<!--                <div class="swiper-wrapper">-->
<!--                    <div class="swiper-slide swiper-slide1"></div>-->
<!--                    <div class="swiper-slide swiper-slide2"></div>-->
<!--                </div>-->
<!--            </div>-->
            <swiper :options="bannerSwiperOption">
                <swiper-slide class="swiper-slide1" />
                <swiper-slide class="swiper-slide2" />
            </swiper>
            <div class="swiper-pagination"></div>
        </div>

        <div class="newswrap">

            <div class="todyns">
                <div class="intitle"><div class="name">今日要闻</div></div>
                <div class="tdbox">
                    <div class="certifybx">
                        <div id="certify">
                            <swiper :options="focusSwiperOption" ref="todaySwiper">
                                <swiper-slide v-for="(c,i) in list_today" :key="i">
                                    <router-link :to="'/news/v/'+c.id">
                                        <div class='img'><img :title='c.title' :src='c.img'/></div>
                                        <div class='titbg'></div><div class='tit'><p>{{ c.title }}</p></div>
                                    </router-link>
                                </swiper-slide>
                            </swiper>
                            <div class="pginate"><div class="swiper-pagination"></div></div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="intitle">
                <div class="name">足球新闻</div>
                <div class="balltab">
<!--                    <router-link to="/news/worldcup">世界杯</router-link>-->
                    <router-link to="/news/yingchao">英超</router-link>
                    <router-link to="/news/xijia">西甲</router-link>
                    <router-link to="/news/dejia">德甲</router-link>
                    <router-link to="/news/ouguan">欧冠</router-link>
                </div>
            </div>
            <div class="newslsbx">
                <div class='bgclist'>
                    <ul>
                        <li class='fi' v-for="(c,i) in list_fb_img" :key="i">
                            <router-link :to="'/news/v/'+c.id">
                                <div class='img'><img :src='c.img'/></div>
                                <div class='tit'><span>{{ c.title }}</span></div>
                            </router-link></li>
                    </ul>
                </div>
                <div class='ballwrap'>
                    <div class="ballbox">
                        <dl :class="list_fb_select===1?'on':''">
                            <dd v-for="(c, i) in list_fb_yc" :key="i" :class="i===5?'mb':''">
                            <router-link :to="'/news/v/'+c.id" >{{ c.title }}</router-link>
                            <span>{{ c.time }}</span>
                            </dd>
                        </dl>
<!--                        <dl :class="list_fb_select===2?'on':''">-->
<!--                            <dd v-for="(c, i) in list_fb_xj" :key="i" :class="i===5?'mb':''">-->
<!--                                <router-link :to="'/news/v/'+c.id" >{{ c.title }}</router-link>-->
<!--                                <span>{{ c.time }}</span>-->
<!--                            </dd>-->
<!--                        </dl>-->
<!--                        <dl :class="list_fb_select===3?'on':''">-->
<!--                            <dd v-for="(c, i) in list_fb_dj" :key="i" :class="i===5?'mb':''">-->
<!--                                <router-link :to="'/news/v/'+c.id" >{{ c.title }}</router-link>-->
<!--                                <span>{{ c.time }}</span>-->
<!--                            </dd>-->
<!--                        </dl>-->
<!--                        <dl :class="list_fb_select===4?'on':''">-->
<!--                            <dd v-for="(c, i) in list_fb_og" :key="i" :class="i===5?'mb':''">-->
<!--                                <router-link :to="'/news/v/'+c.id" >{{ c.title }}</router-link>-->
<!--                                <span>{{ c.time }}</span>-->
<!--                            </dd>-->
<!--                        </dl>-->
                    </div>
                </div>
            </div>

            <div class="intitle">
                <div class="name">篮球新闻</div>
                <div class="balltab">
                    <router-link to="/news/nba">NBA</router-link>
                    <router-link to="/news/cba">CBA</router-link>
                </div>
            </div>
            <div class="newslsbx">
                <div class='bgclist'>
                    <ul>
                        <li class='fi' v-for="(c,i) in list_bk_img" :key="i">
                            <router-link :to="'/news/v/'+c.id">
                                <div class='img'><img :src='c.img'/></div>
                                <div class='tit'><span>{{ c.title }}</span></div>
                            </router-link></li>
                    </ul>
                </div>
                <div class='ballwrap'>
                    <div class="ballbox">
                        <dl :class="list_bk_select===1?'on':''">
                            <dd v-for="(c, i) in list_bk_nba" :key="i" :class="i===5?'mb':''">
                                <router-link :to="'/news/v/'+c.id" >{{ c.title }}</router-link>
                                <span>{{ c.time }}</span>
                            </dd>
                        </dl>
<!--                        <dl :class="list_bk_select===2?'on':''">-->
<!--                            <dd v-for="(c, i) in list_bk_cba" :key="i" :class="i===5?'mb':''">-->
<!--                                <router-link :to="'/news/v/'+c.id" >{{ c.title }}</router-link>-->
<!--                                <span>{{ c.time }}</span>-->
<!--                            </dd>-->
<!--                        </dl>-->
                    </div>
                </div>
            </div>


            <div class="fenxibox">
                <div class="intitle">赛前动态<router-link to="/news/saiqian" class="more">更多+</router-link></div>
                <div class="item">
                    <div class="li" v-for="(c, i) in list_fx1" :key="i"><router-link :to="'/news/v/'+ c.id" >{{ c.title }}</router-link><span>{{ c.time }}</span></div>
                </div>
                <div class="intitle">百家贴士<router-link to="/news/baijia" class="more">更多+</router-link></div>
                <div class="item">
                    <div class="li" v-for="(c, i) in list_fx2" :key="i"><router-link :to="'/news/v/'+ c.id" >{{ c.title }}</router-link><span>{{ c.time }}</span></div>
                </div>
                <div class="intitle">足球前瞻<router-link to="/news/qianzhan" class="more">更多+</router-link></div>
                <div class="item">
                    <div class="li" v-for="(c, i) in list_fx3" :key="i"><router-link :to="'/news/v/'+ c.id" >{{ c.title }}</router-link><span>{{ c.time }}</span></div>
                </div>
                <div class="intitle">前线爆料<router-link to="/news/qianxian" class="more">更多+</router-link></div>
                <div class="item">
                    <div class="li" v-for="(c, i) in list_fx4" :key="i"><router-link :to="'/news/v/'+ c.id" >{{ c.title }}</router-link><span>{{ c.time }}</span></div>
                </div>
                <div class="intitle">欧亚攻略<router-link to="/news/ouya" class="more">更多+</router-link></div>
                <div class="item">
                    <div class="li" v-for="(c, i) in list_fx5" :key="i"><router-link :to="'/news/v/'+ c.id" >{{ c.title }}</router-link><span>{{ c.time }}</span></div>
                </div>
                <div class="intitle">盘口分析<router-link to="/news/pankoufenxi" class="more">更多+</router-link></div>
                <div class="item">
                    <div class="li" v-for="(c, i) in list_fx6" :key="i"><router-link :to="'/news/v/'+ c.id" >{{ c.title }}</router-link><span>{{ c.time }}</span></div>
                </div>
            </div>

            <template v-if="links.length > 0">
            <div class="intitle intitle_lk">
                <div class="name">友情链接</div>
            </div>
            <div class="links">
                <span v-for="(c,i) in links" :key="i"><a :href="c.url" target="_blank">{{c.name}}</a><i v-if="i < links.length-1"/></span>
            </div>
            </template>

        </div>

        <div class="fotbox">
            <div class="foticon">
                <router-link to="/about" class="lk mt"><i class="icon_ab"/>关于<span>我们</span></router-link>
                <router-link to="/mianze" class="lk"><i class="icon_mz"/>免责<span>声明</span></router-link>
                <router-link to="/treaty" class="lk"><i class="icon_ct"/><span>用户</span>协议</router-link>
                <router-link to="/help" class="lk"><i class="icon_hp"/>帮助<span>中心</span></router-link>
                <router-link to="/contact" class="lk"><i class="icon_ct"/>联系<span>我们</span></router-link>
            </div>
            <div class="copyright">
                <p>烽行体育所有资讯产品足球篮球预测、足球篮球分析内容仅作为中国体育彩票竞彩参考。彩市有风险，购彩需谨慎！烽行体育不对彩民任何购买行为负责，以上条款，在不违背有关法律、法规，不违反公共道德准则的情况下，由烽行体育作最终解释、补充，或另行约定附则。</p>
                <p class="py">Copyright © 烽行体育 All Rights Reserved. Popular sports information. Company address: Hong Kong Kowloon DongShanLu TianHeDianNaoCheng no. 889-1206</p>
            </div>
        </div>
    </template>

    </div>
</template>

<script>
    import "../assets/css/news.css"
    // import match_mini_index from './public/match_mini_index'
    export default {
        name: "index",
        components: {
            // match_mini_index
        },
        // computed(){
        //     // swiper() {
        //     //     return this.$refs.mySwiper.swiper
        //     // }
        // },
        data() {
            let _vm = this
            return {
                init: true,
                list_today: [],
                list_tj: [],

                list_fb_img: [],
                list_fb_yc: [],
                list_fb_xj: [],
                list_fb_dj: [],
                list_fb_og: [],
                list_fb_select: 1,

                list_bk_img: [],
                list_bk_nba: [],
                list_bk_cba: [],
                list_bk_select: 1,

                // list_match: [],
                // list_match_bk: [],

                list_fx1: [],
                list_fx2: [],
                list_fx3: [],
                list_fx4: [],
                list_fx5: [],
                list_fx6: [],

                focus_tab: 0,
                bannerSwiperOption: {
                    // slidesPerView: 1,
                    autoplay: {
                        delay: 6000,
                        disableOnInteraction: false
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        el: '#banner .swiper-pagination'
                    },
                },
                focusSwiperOption: {
                    // slidesPerView: 1,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    },
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        el: '.pginate .swiper-pagination'
                    },
                    on: {
                        slideChangeTransitionStart: function () { //slideChangeTransitionStart
                            //console.log(vue.focus_tab)
                            //console.log(this.activeIndex)
                            _vm.focus_tab = this.realIndex
                        }
                    }
                },
                fx_tabs: ['赛前动态', '百家贴士', '足球前瞻', '前线爆料', '欧亚攻略', '盘口分析'],
                fx_tabs_active: 0,

                links: []
            }
        },
        watch: {
            // '$route': {
            //     handler () {
            //         document.documentElement.scrollTop = this.$route.meta.y
            //     }
            // },
        },
        created() {
            this.getList()
        },
        methods: {
            // mousemoveFootball(i){
            //     this.list_fb_select = i
            // },
            // mousemoveBaskball(i){
            //     this.list_bk_select = i
            // },
            getList(){
                let that = this
                that.$get(that.$api.news_list, {}).then(function (res) {
                    if(res.code === 1){
                        that.list_today = res.data.list_today
                        // that.list_tj = res.data.list_tj
                        that.list_fb_img = res.data.list_fb_img
                        that.list_fb_yc = res.data.list_fb_yc
                        // that.list_fb_xj = res.data.list_fb_xj
                        // that.list_fb_dj = res.data.list_fb_dj
                        // that.list_fb_og = res.data.list_fb_og
                        that.list_bk_img = res.data.list_bk_img
                        that.list_bk_nba = res.data.list_bk_nba
                        // that.list_bk_cba = res.data.list_bk_cba
                        // that.list_match = res.data.list_match
                        // that.list_match_bk = res.data.list_match_bk
                        that.list_fx1 = res.data.list_fx1
                        that.list_fx2 = res.data.list_fx2
                        that.list_fx3 = res.data.list_fx3
                        that.list_fx4 = res.data.list_fx4
                        that.list_fx5 = res.data.list_fx5
                        that.list_fx6 = res.data.list_fx6
                        that.links = res.data.links

                        that.init = false
                    }
                })
            },
        },
        computed: {
            // swiper(){
            //     return this.$refs.todaySwiper.swiper
            // }
        },
        // beforeRouteEnter(to, from, next){
        //     next(vm =>{
        //         document.documentElement.scrollTop = vm.$route.meta.y
        //     })
        // }
    }
</script>

<style scoped>
</style>
